/**
 * @generated SignedSource<<7e85a0c6cfec4696f05568f73e071daf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "9f2ae95a166d3147e74c587f0809843f";

export default node;
